/**
 * Extracts and returns the file extension from a filename string (e.g. `"document.pdf"` → `"pdf"`).
 * Returns `undefined` if the name is empty or has no extension.
 */
export const getExtensionFromName = (name = '') => {
    if (!name) {
        return undefined;
    }

    return name.slice((Math.max(0, name.lastIndexOf('.')) || Infinity) + 1);
};
